import { create } from "zustand/react";
import { OrderStatus } from "@/types";

/** Rows per page the orders list opens with. Also the fallback when a persisted filter has no limit. */
export const DEFAULT_ORDERS_PAGE_SIZE = 30;

type OrderState = {
  currentPage: number;
  numberOfPages: number;
  limit: number;
  sortDirection: "ASC" | "DESC";
  setSortDirection: (sortDirection: "ASC" | "DESC") => void;
  setPage: (page: number) => void;
  setNumberOfPages: (numberOfPages: number) => void;
  setLimit: (limit: number) => void;
  statuses: OrderStatus[];
  setStatuses: (statuses: OrderStatus[]) => void;
  orderTypes: number[] | null;
  setOrderTypes: (orderTypes: number[] | null) => void;
  onlyPromoted: boolean;
  setOnlyPromoted: (onlyPromoted: boolean) => void;
  salesItemId: number | null;
  setSalesItemId: (salesItemId: number | null) => void;
  sortBy: string;
  setSortBy: (sortBy: string) => void;
  reset: () => void;
};

export const useOrderStore = create<OrderState>((set) => ({
  currentPage: 1,
  numberOfPages: 0,
  limit: DEFAULT_ORDERS_PAGE_SIZE,
  sortDirection: "DESC",
  setSortDirection: (sortDirection: "ASC" | "DESC") => set({ sortDirection }),
  setPage: (page) => set({ currentPage: page }),
  setNumberOfPages: (numberOfPages) => set({ numberOfPages }),
  setLimit: (limit) => set({ limit }),
  // No status is pre-selected: the list opens unfiltered and the user narrows it.
  statuses: [],
  setStatuses: (statuses: OrderStatus[]) => set({ statuses, currentPage: 1 }),
  orderTypes: null,
  setOrderTypes: (orderTypes: number[] | null) => set({ orderTypes, currentPage: 1 }),
  onlyPromoted: false,
  setOnlyPromoted: (onlyPromoted: boolean) => set({ onlyPromoted, currentPage: 1 }),
  salesItemId: null,
  setSalesItemId: (salesItemId: number | null) => set({ salesItemId, currentPage: 1 }),
  sortBy: "date",
  setSortBy: (sortBy: string) => set({ sortBy }),
  reset: () =>
    set({
      currentPage: 1,
      limit: DEFAULT_ORDERS_PAGE_SIZE,
    }),
}));
